exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-2f482efb]{overflow-x:auto}[dir] .modal[data-v-2f482efb]{text-align:center;padding:0!important}.modal[data-v-2f482efb]:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}[dir=ltr] .modal[data-v-2f482efb]:before{margin-right:-4px}[dir=rtl] .modal[data-v-2f482efb]:before{margin-left:-4px}.modal-dialog[data-v-2f482efb]{display:inline-block;vertical-align:middle}[dir=ltr] .modal-dialog[data-v-2f482efb]{text-align:left}[dir=rtl] .modal-dialog[data-v-2f482efb]{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f482efb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/deliveryInvoice/ViewAttachedShippingInvoices.vue
// module id = 1255
// module chunks = 0